import React from "react";
import UserProfileComponent from "../UserProfileComponent";
import { ClearSessionItems } from "../../helper/appsession";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { companySlice, setCompany } from "../../redux/companySlice";
import ChangeCompanyComponent from "../Shared/ChangeCompanyComponent";

export default function HeaderComponent() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const userCompany = useSelector((state) => state?.company?.data);
  //console.log("Login Page user: " + JSON.stringify(user));
  // console.log("Login Page userCompany: " + JSON.stringify(userCompany));
  return (
    <>
      <div className="top-bar-company">
        <span>
          <a className="nav-link" data-widget="pushmenu" href="#" role="button">
            <Icon
              icon="material-symbols:menu-open-rounded"
              width="24"
              height="24"
            />
          </a>
        </span>
        <span
          className="nav-link"
          data-widget="fullscreen"
          role="button"
          style={{ padding: "0px", marginTop: "5px" }}
        >
          <img
            src={`./assets/img/Company/${userCompany?.companyId}/company-logo.png`}
            //src={`./${userCompany?.companyLogoPath}`}
            alt="VISHWAM"
            className="brand-image"
            height="35px"
          />
        </span>
      </div>
      <nav className="main-header navbar navbar-expand navbar-dark navbar-dark">
        <ul className="navbar-nav">
          {/* <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <Icon
                icon="material-symbols:menu-open-rounded"
                width="24"
                height="24"
              />
            </a>
          </li> */}
          <li className="nav-item">
            <h3 className="pagetitle mb-0" id="pageTitle"></h3>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          {/* <li className="nav-item">
              <a
                className="nav-link"
                data-widget="fullscreen"
                href="#"
                role="button"
              >
                <i className="fas fa-expand-arrows-alt" />
              </a>
            </li>  */}
          {/* <li className="nav-link">
            <b>[{user?.companyName}]</b>
          </li> */}
          {/* <li className="nav-item">
            <span
              className="nav-link"
              data-widget="fullscreen"
              role="button"
              style={{ padding: "0px", marginTop: "5px" }}
            >
              <img
                src={`./assets/img/Company/${user?.companyId}/company-logo.png`}
                alt="VISHWAM"
                className="brand-image"
                height="35px"
              />
            </span>
          </li> */}
          <li className="nav-item">
            <a
              className="nav-link dropdown-toggle user"
              type="button"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              href="#"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Icon icon="mingcute:user-2-line" width="20" height="20" />
              &nbsp;
              {user.userName}&nbsp;({userCompany?.companyCode})
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <li className="nav-item">
                <span
                  className="nav-link"
                  style={{
                    borderBottom: "1px solid silver",
                    marginBottom: "2px",
                    paddingTop: "0px",
                  }}
                >
                  {user?.firstName
                    ? user?.firstName + " " + user?.lastName
                    : user?.userName}
                </span>
              </li>
              <li className="nav-item">
                <span
                  className="nav-link"
                  data-widget="pushmenu"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    dispatch(
                      setCompany({
                        id: userCompany?.id || 1,
                        isChangeCompanyModalOpen:
                          !userCompany?.isChangeCompanyModalOpen,
                      })
                    );
                  }}
                >
                  <i className="fas fa-exchange-alt"></i> Switch Company
                </span>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  onClick={() => {
                    ClearSessionItems();
                    localStorage.clear();
                    window.location.href = "/";
                  }}
                >
                  <i className="fas fa-sign-out-alt"></i> Exit
                </a>
              </li>
            </div>
          </li>
          {/* Change Company */}
        </ul>
      </nav>
      {/* <div>
        <div className="flex-column justify-content-center align-items-center" />
       
      </div> */}
      {userCompany?.isChangeCompanyModalOpen && <ChangeCompanyComponent />}
    </>
  );
}
